import React from 'react';
import classnames from 'classnames';
import styles from './LoadMoreButton.module.less';
import Button from './Button';
import { ButtonProps } from 'antd/lib/button/button';
import { useTranslation } from 'react-i18next';

type LoadMoreButtonProps = {
  className?: string;
  loading?: boolean;
} & ButtonProps;
const LoadMoreButton = (props: LoadMoreButtonProps) => {
  const { loading, className, ...rest } = props;
  const { t } = useTranslation();
  return (
    <Button className={classnames([styles.button, className])} disabled={loading} loading={loading} {...rest}>
      {loading ? t('general.loading') : t('general.loadMore')}
    </Button>
  );
};

export default LoadMoreButton;
